<template>
  <div class="p-20">
    <van-form ref="form" :show-error="false" label-width="100" error-message-align="right">
      <van-cell-group>
        <div v-for="(item,index) in gatherDomList" :key="index" v-if="isShow(item.id)">
          <van-field :label="item.title" class="fileValueBox"   input-align="right" :value.prop="formData[item.id]">
          <!-- <van-field :label="item.title" input-align="right" :value.prop="formData[item.id]" :required="isRequired(item.id)" :rules="getRules(item.id)"> -->
            <template #input>
              <div v-if="item.name === 'FileUpload'" class="width-100">
                <div class="width-100">
                  <!-- <div v-if="isEdit(item.id) == 'E'"> -->
                    <uploadFiles :disabled="isDisabled('fj')" :files="formData.fj" @success="uploadSuccess"
                                 module-type="flow" @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','fj')"></uploadFiles>
                  <!-- </div>
                  <div v-for="(itm, inx) in formData[item.id]" :key="inx" @click="predivImage(inx,formData[item.id])">
                    <van-image v-if="imageTypeList.findIndex(type => itm.fileType === type) !== -1" :src="itm.previewUrl" width="91" height="91"></van-image>
                  </div> -->
                </div>

                <!-- <div :class="{'m-t-10': inx > 0}" class="cor-4185EE"
                     v-if="documentTypeList.findIndex(type => itm.fileType === type) !== -1 || documentTypeList.findIndex(type => getFileExtension(itm.name) === type) !== -1"
                     v-for="(itm,inx) in formData[item.id]" :key="inx" @click="pview(itm)">
                  {{ itm.name || itm.fileName }}
                </div> -->
              </div>
              <div v-if="item.name === 'UserPicker'">
                {{ formData[item.id][0].name }}
              </div>
             <div v-if="item.name !== 'UserPicker'">
               <div v-if="formData[item.id]">
                
                <div v-if="item.id == 'hkry'">{{userName}}</div>
                <div v-else-if="item.name !== 'FileUpload'">{{ formDataItemId(formData, item) || '无' }}</div>
                <!-- <view-item v-else-if="item.name !== 'FileUpload'" :value="formData[item.id] + ''"></view-item> -->
              </div>

              <div v-else>无</div>
             </div>

            </template>
          </van-field>
        </div>
      </van-cell-group>
        <div v-for="(item,index) in relativeFlowList" :key="index" v-if="isShow(item.id)">
        <div class="font-32 font-weight-500 cor-00 m-t-26">{{ formData[item.id].length > 0 ? item.title : '' }}</div>
        <div class="m-t-20">
        <van-cell-group v-for="(ele,i) in formData[item.id]" :key="index" class="b-r-10 m-t-20 p-20">
          <div class="flex col-center row-between">
            <!-- 标题 -->
            <div class="flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10">
              {{ ele.title }}
            </div>
          </div>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">流程状态</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ ele.businessStatusName }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">申请时间</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ ele.startTime ? moment(ele.startTime).format('YYYY-MM-DD HH:mm') : '' }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">完成时间</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ ele.endTime ? moment(ele.endTime).format('YYYY-MM-DD  HH:mm') : '' }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">摘要</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30">
                {{ ele.summary }}
              </div>
            </van-col>
          </van-row>
             <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">事由</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30">
                {{ ele.sy }}
              </div>
            </van-col>
          </van-row>
        </van-cell-group>
        </div>
      </div>
      <div v-for="(item,index) in independentDomList" :key="index" v-if="isShow(item.id)">
        <div class="font-32 font-weight-500 cor-00 m-t-26">{{ formData[item.id].length > 0 ? item.title : '' }}</div>
        <div class="m-t-20">
          <div v-for="(ele,i) in formData[item.id]" :key="i" class="m-t-20">
            <van-row class="bg-FF p-b-6" style="border-bottom: 1px solid #EBEBEB">
              <van-col :span="11">
                <img class="w-10 h-28" :src="`${image_base_url}/icon_line.png`"></img>
                <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `明细${i + 1}` }}</span>
              </van-col>
            </van-row>
            <van-field v-for="(rowConfig,rowIndex) in item.props.columns" input-align="right" :key="rowIndex"
                       :label="rowConfig.title">
              <template #input>
                <view-item v-if="ele[rowConfig.id]" :value="ele[rowConfig.id]  + ''" :placeholder="''"></view-item>
                <div v-else-if="rowConfig.id == 'summary'">
<!--                  <span>关联单号：<span style="cursor: pointer;color: #4877E4" title="点击查看借款付款流程">{{ ele.businessNo }}</span></span><br>-->
                  <span>关联单号：{{ ele.businessNo }}</span><br>
                  <span>借款时间：{{ parseTime(ele.debtTime, '{y}-{m}-{d} {h}:{i}') }}</span><br>
                  <span>借款类型：{{ getDebtType(ele.debtType) }}</span><br>
                  <span>事由：{{ ele.debtReason }}</span>
                </div>
                <div v-else>无</div>
              </template>
            </van-field>
          </div>
        </div>
      </div>
    </van-form>


    <div class="font-32 font-weight-500 cor-00 m-t-26">流程</div>
    <!--      这个是不带选人的流程图    -->
    <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class="m-t-20"
               :flowTraceList="flowTrace" :processInfo="processData"></flowTrace>
    <bottom-bar @submit="submit" @mention="mention"></bottom-bar>


  </div>
</template>
<script>

import mixin from '@/mixin/flow'
import flowTrace from "@/components/flow/flowTrace.vue";
import bottomBar from "@/components/flow/bottom-bar.vue";
import moment from "moment";
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import * as ww from '@wecom/jssdk'
import {getFileExtension, parseTime} from "@/utils/ruoyi";
import {getRemoteData} from "@/api/flow";


export default {
  mixins: [mixin,fileMixins],
  components: {bottomBar, flowTrace, uploadFiles},
  data() {
    return {
      moment,
      formData: {
        fj:[]
      },
      independentDom: ['TableList'],
      imageTypeList: ['png', 'jpg', 'jpeg', 'gif', 'webp'],
      documentTypeList: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt'],
      // 独立分栏dom树 同时他也是特殊类型的数据 需要独立处理
      independentDomList: [],
      // 集中分栏
      gatherDomList: [],
      relativeFlowList: [],//例如作废功能的关联流程数据
      relativeFlowTitle: [],//例如作废功能的关联流程数据
      userName:'',
      rules: {},
    }
  },
  async created() {
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    if (this.$route.query.processInstanceId && !this.$route.query.reSend) { // 外部跳转时
      this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
      if (this.$route.query.taskId) {
        this.SET_TASK_ID(this.$route.query.taskId)
      }
      this.$loading.show()
     await this.getProcessInfo({
        processInstanceId: this.$route.query.processInstanceId,
        taskId: this.$route.query.taskId
      }).then(res => {
        console.log(res.data, 222)
        // 合并this.formData
        this.formData = {
          ...this.formData,
          ...res.data.formData
        }
        // Object.assign(this.formData, res.data.formData)
        this.getUserName(this.formData.hkry)
        const formTemplateData = JSON.parse(res?.data?.processTemplates?.formItems)
        // const perms = res.data?.currentNode?.props?.formPerms || []
        // 給SET_PERMS赋值
        // this.SET_PERMS(perms)

        this.relativeFlowTitle=res?.data?.processTemplates.formName
        this.buildNodeTree(formTemplateData)
        this.$loading.hide()
      })
    }
    console.log(this.formData,'this.formData')
  },
  methods: {
    parseTime,
    getFileExtension,
    pview(item) {
      if (this.$store.state.user.environmentType === 1) {
        this.registerWw().then(() => {
          console.log('registerWw completed, calling filePreview');
          ww.previewFile({
            url: item.previewUrl, // 需要预览文件的地址(必填，可以使用相对路径)
            name: item.name, // 需要预览文件的文件名，必须有带文件格式的后缀，例如.doc(不填的话取url的最后部分，最后部分是个包含格式后缀的文件名)
            size: item.fileSize,// 需要预览文件的字节大小(必填，而且大小必须正确，否则会打开失败)
          });
        }).catch((error) => {
          console.error('registerWw failed:', error);
          // 即使注册失败也尝试预览文件
          ww.previewFile({
            url: item.previewUrl, // 需要预览文件的地址(必填，可以使用相对路径)
            name: item.name, // 需要预览文件的文件名，必须有带文件格式的后缀，例如.doc(不填的话取url的最后部分，最后部分是个包含格式后缀的文件名)
            size: item.fileSize,// 需要预览文件的字节大小(必填，而且大小必须正确，否则会打开失败)
          });
        });
      } else {
        this.wwRegister(window.encodeURIComponent(location.href.split('#')[0]), ww => {
          ww.previewFile({
            url: item.previewUrl, // 需要预览文件的地址(必填，可以使用相对路径)
            name: item?.name,
            size: item.fileSize,
            success: function (res) {
              console.log('成功打开附件API', res)
            },
            fail: function (res) {
              console.log('打开附件API失败', res)
              // 在这里处理失败的情况，例如提示用户或进行其他操作
            }
          })
        })
      }
    },
    formDataItemId(formData, item){
      console.log('formDataItemId', formData, item)
      let itemData=''
       // 获取字段值，添加默认值处理
      let fieldValue = formData[item.id]
      if(item.name=='MultipleSelect'){
       itemData= fieldValue.toString()
      }else{
      // 其他字段类型处理
         itemData = fieldValue.toString()
        
        // 如果是逗号分隔的字符串，取逗号后面的部分
        if (itemData.includes(',')) {
          const parts = itemData.split(',')
          // 取逗号后面的所有部分，用逗号重新连接
          return parts.slice(1).join(',')
        }
      }
      return itemData
    },
    buildNodeTree(data) {
      console.log(data,'data数据处理---------------------------1')
      for (let i = 0; i < data.length; i++) {
        if (data[i].name === 'SpanLayout' || data[i].name === 'Divider') {
          if (data[i].props.items) this.buildNodeTree(data[i].props.items);
        }else if (data[i].name == 'RelativeFlow') {
           this.relativeFlowList.push(data[i])
        } else {
          if (this.independentDom.findIndex(item => item === data[i].name) !== -1) {
            this.independentDomList.push(data[i])
          } else {
            this.gatherDomList.push(data[i])
          }
        }
      }
      console.log(this.independentDomList,'this.gatherDomList')
    },
    // 是否编辑
    isEdit(field) {
      // console.log(this.perms)
      if (this.perms.length > 0) {
        const item = this.perms.find(item => item.id === field)
        if (!item) {
          return false
        }
        return item.perm
      }
    },
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
      // console.log(fileList)
      this.formData.fj = fileList
    },
    getUserName(value) {
      if (!value) {
        return
      }
      getRemoteData('/system/user/getUser?userId=' + value, 'get', {}).then(response => {
        if (response.data) {
          let user = response.data
          this.userName = user.nickName
        }
      }).catch(err => {
        this.userName = value
      });
    },
    getDebtType(type){
      if(type==1){
        return "供应商货款"
      }else{
        return "个人借款（备用金）"
      }
    },
  }
}
</script>
